<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Improve 1'"></cardHead>
      <div>
        <div class="left">
          <Form
            method="dialog"
            v-slot="{ errors }"
              class="floating-labels row  p-20 p-b-10"
            ref="form"
          >
              <div class="col">
            <formGroup
              :title="'StartDate'"
              v-model="model.StartDate"
              :errors="errors"
              :rules="{ required: true }"
              :max="model.EndDate"
              :disabled="process"
              type="date"
            ></formGroup>
              </div>
              <div class="col">
            <formGroup
              :title="'EndDate'"
              v-model="model.EndDate"
              :errors="errors"
              :rules="{ required: true }"
              type="date"
              :min="model.StartDate"
              :disabled="process"
            ></formGroup>
              </div>
              <div class="col">

              <multiSelect
                :title="'Years'"
                v-model="model.Years"
                :errors="errors"
                :data="
                  years.map((x) => {
                    return {
                      value: x,
                      title: x.toString(),
                    };
                  })
                "
              >
              </multiSelect>
              </div>
              <div class="col-auto">
            <Btn
              class="btn-primary tcenter w100"
              @click="
                data = {};
                get();
              "
              :process="process"
              :disabled="process || model.Years.length == 0"
              >Search</Btn
            >
              </div>
          </Form>
        </div>
        <div class="right">
          <ul>
            <li v-for="item in Object.entries(data).sort((x,y)=>x[1].length-y[1].length)" :key="item[0]">
              <h4 class="card-title card-title">{{ item[0] }}</h4>

            <dataTable
              :name="'Improve1'+item[0]"
              ref="agGrid"
              :data="item[1]"
              :columnDefs="getColumnDefs(Object.keys(item[1][0]??{}))"
            ></dataTable>
            </li>
          </ul>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiSelect from "./../../../components/formGroup/multiSelect.vue";
import moment from "moment";
export default {
  name: "Improve1",
  components: { multiSelect },
  data() {
    return {
      model: {
        StartDate: "2023-09-01",
        EndDate: "2023-09-30",
        Years: [2026,2025],
      },
      data: {},
      process: false,
      years:[2026,2025,2024,2023]
    };
  },
  created() {
    this.model.EndDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.model.StartDate = this.$moment(
      new Date().setDate(new Date().getDate() - 7)
    ).format("YYYY-MM-DD");
    this.get();
  },
  methods: {
    get() {
      this.process = true;
      this.$appAxiosAdmin
        .post(`Research/Improve1`, this.model)
        .then((response) => {
          this.data = response.data;
          this.process=false;
        });
    },
    setSelect(item) {
      if (this.model.Years.indexOf(item) > -1) {
        this.model.Years.splice(this.model.Years.indexOf(item), 1);
      } else {
        this.model.Years.push(item);
      }
    },
    getColumnDefs(items){
      // {"headerName":"ReportYear","field":"ReportYear","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"minWidth":140}
      return items.map(x=>{
        return {
          headerName:x,
          field:x,
          enableRowGroup:true,
          floatingFilter:true,
          flex:1,
          minWidth:140,
          valueFormatter: function(params) {
            if(x=="Date"){
              return moment(new Date(params.value)).format("DD.MM.YYYY");
            }else{
              return params.value;
            }
          },
        }
      })
    }
  },
};
</script>
<style scoped>
h4{
  margin:  0;
  padding: 10px 16px;
  background: #ddd;
}
</style>
